export type FriendAvatar = {
  id: string;
  name: string;
  imageUrl?: string | null;
};

export type FriendAvatarsStackProps = {
  friends: FriendAvatar[];
  max?: number;
  limit?: number;
  size?: number;
  className?: string;
};

function initials(name: string) {
  return name.trim().slice(0, 1).toUpperCase() || 'Х';
}

export function FriendAvatarsStack({ friends, max = 3, limit, size = 28, className }: FriendAvatarsStackProps) {
  const effectiveMax = limit ?? max;
  const visible = friends.slice(0, Math.max(0, effectiveMax));
  const rest = Math.max(0, friends.length - visible.length);

  return (
    <span
      className={['hopper-avatar-stack', className].filter(Boolean).join(' ')}
      aria-label={friends.length ? `Друзья: ${friends.map((friend) => friend.name).join(', ')}` : 'Нет друзей'}
    >
      {visible.map((friend) => (
        <span className="hopper-avatar-stack__avatar" key={friend.id} style={{ width: size, height: size }} aria-hidden="true">
          {friend.imageUrl ? <img src={friend.imageUrl} alt="" loading="lazy" /> : initials(friend.name)}
        </span>
      ))}
      {rest > 0 && (
        <span className="hopper-avatar-stack__rest" style={{ width: size, height: size }} aria-hidden="true">+{rest}</span>
      )}
    </span>
  );
}
